<template>
  <section class="padding">
    <header>
      <h4 class="h4">Li’l Yogis by Sabrina Merchant | Feb 25, 2020 | 2 min read</h4>
      <h1>Marina animal yoga <br> poses</h1>
    </header>

<div class="blog_body">
  <h4>
    Inspired from incredible creatures that inhabit our oceans these yoga postures are a great way to introduce <br> children to yoga. There is something about the calm blue waters of the ocean and the wonderful animals <br> living in it that just fascinates children. Practicing yoga helps children stay calm and fit , it reduces stress and <br> helps them grow mentally and physically stronger. Teach your children more about ocean animals and help <br> them connect with nature with these fun Ocean Yoga poses:
  </h4>
  <br>
  <h3>
    1. Shark Pose 
  </h3>
  <br>
  <h4>Shark pose isn't so much of a back bend as it is an exercise to lengthen the spine. It will also open the chest and <br> lungs while stretching the shoulders and strengthening the arms, back and core muscles. </h4>
<br>
<img class="blog_image" src="../../../assets/blog1.png" alt="">
<br>
<br>
<h3>
  How to Do   
</h3>
<br>
<h4>
  1. Begin by lying down on your belly.  
  <br>
2. Clasp your hands behind your back to make a shark fin.   
<br>
3. Breathe in and lift your arms, leg and chest all at the same time. Keep your neck long and eyes on a focus point in front of you.  <br>
4. Slowly bring your chest, legs and arms back down to the floor and relax.      
Benefits  - Strengthen   - Stretch    <br> 
2. Crab Pose/Ardha Purvottanasana  Time to get some movement with the most famous pinchers of the land and sea- crabs!
</h4>
<br>
<img class="blog_image" src="../../../assets/blog2.png" alt="">
<br>
<br>
<h3>
  How to Do   
</h3>
<br>
<h4>
  1. Begin by lying down on your belly.  
  <br>
2. Clasp your hands behind your back to make a shark fin.   
<br>
3. Breathe in and lift your arms, leg and chest all at the same time. Keep your neck long and eyes on a focus point in front of you.  <br>
4. Slowly bring your chest, legs and arms back down to the floor and relax.      
Benefits  - Strengthen   - Stretch    <br> 
2. Crab Pose/Ardha Purvottanasana  Time to get some movement with the most famous pinchers of the land and sea- crabs!
</h4>

</div>
<br>
<br>

<div class="share">
  <h3>Share this post on </h3>
  <div class="social_icons">
  <img class="icon" src="../../../assets/whatsapp.png" alt="">
  <img  class="icon" src="../../../assets/facebook.png" alt="">
  <img class="icon" src="../../../assets/twitter.png" alt="">
  </div>
</div>


<div class="line">

</div>

  </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.blog_image{
      width: 100%;
    height: auto;
}
h1{
    color: #791E94;
    
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    padding: 30px;
}
.line{
  height: 1px;
  background-color: black;
  margin-top: 20px;
  max-width: 50%;
  margin-left: 485px;
}
.icon{
cursor: pointer;
}
.social_icons{
      padding-left: 20px;
    display: flex;
    justify-content: space-evenly;
    width: 211px;
    
}
.share{
      width: 50%;
    margin: auto;
    display: flex;
    align-items: center;
}
.blog_body{
  width: 50%;
    margin: auto;
}
h4{
    color: #44526B;
    font-weight: 500;
    line-height: 200%;
    text-align: left;
}
.h4{
  text-align: center;
}
h1{
  text-align: center;
}
.padding{
      padding-top: 12rem;
}
@media (max-width : 1080px){
  .blog_body{
    width: 90%;
    margin: auto;
  }
}
</style>